import { render } from "./WCFooter.vue?vue&type=template&id=fd52020c&scoped=true"
import script from "./WCFooter.vue?vue&type=script&lang=js"
export * from "./WCFooter.vue?vue&type=script&lang=js"

import "./WCFooter.vue?vue&type=style&index=0&id=fd52020c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd52020c"]])

export default __exports__